module.exports = __webpack_public_path__ + "static/media/oportunidades_logo.990a53e5.png";